import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface Edit2IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const Edit2Icon = ({ className, ...props }: Edit2IconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 20.2501C21.4142 20.2501 21.75 20.5858 21.75 21.0001C21.75 21.4142 21.4142 21.7501 21 21.7501H3C2.58581 21.7501 2.25003 21.4142 2.25 21.0001C2.25 20.5858 2.58579 20.2501 3 20.2501H21ZM14.5195 2.46979C14.8124 2.17689 15.2882 2.17689 15.5811 2.46979L20.5303 7.41901C20.8231 7.71183 20.823 8.18664 20.5303 8.47955L12.0957 16.9151C11.7676 17.2432 11.3223 17.4267 10.8584 17.4268H6.32227C5.90835 17.4266 5.5725 17.0917 5.57227 16.6778V12.1417C5.57238 11.6777 5.75688 11.2324 6.08496 10.9044L14.5195 2.46979ZM7.14551 11.9649C7.09873 12.0117 7.07238 12.0755 7.07227 12.1417V15.9278H10.8584C10.9245 15.9277 10.9884 15.9013 11.0352 15.8546L16.1113 10.7784L12.2217 6.88873L7.14551 11.9649ZM13.2822 5.82819L17.1719 9.71783L18.9395 7.94928L15.0498 4.06061L13.2822 5.82819Z"
      fill="currentColor"
    />
  </svg>
);

export default Edit2Icon;
